import React from "react";
import _ from "lodash";
import { Card, CardImg, CardText, CardBody, CardTitle, Button, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { IMAGE_URL } from "../actions/types";
const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
};

const ProductsLanding = (props) => {
  const products = _.map(props);
  if (products.length) {
    return (
      <Col xs="12" style={{ marginBottom: "20px" }}>
        <Slider {...settings}>
          {products.map((product) => {
            const desc = { __html: product.description };
            const cardImg = product.images[0] ? (
              <CardImg top src={`${IMAGE_URL}/360/${product.images[0]}`} alt="Card image cap" />
            ) : (
              ""
            );
            return (
              <div key={product.name}>
                <Card style={{ height: "auto" }}>
                  {cardImg}
                  <CardBody>
                    <CardTitle>{decodeURIComponent(product.name)}</CardTitle>
                    <CardText>
                      <span dangerouslySetInnerHTML={desc} />
                    </CardText>
                    <Link to={`/${product.ParentCategory}/${product.SubCategory}/${product.name}`}>
                      <Button>Katso!</Button>
                    </Link>
                  </CardBody>
                </Card>
              </div>
            );
          })}
        </Slider>
      </Col>
    );
  }
  return <div>Ladataan tuotteita....</div>;
};

export default ProductsLanding;
